export default "__VITE_ASSET__2f8c19cf__"